<template>
  <div class="container is-max-desktop px-2">
    <keep-alive :include="['QuizView']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  created() {
    localStorage.setItem('unique_key', this.$store.state.unique_key);
  },
};
</script>
